import { FC } from "react"
import { Ticket } from "../../../types/slices/ticketType"
import { Grid, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import CustomTable from "../../../components/common/CustomTable/CustomTable"
import { withStyles } from '@mui/styles';
import { moneyCL } from "../../../toolbox/helpers/money-helpers";

interface DocumentDetailPros {
    ticket: Ticket
    idtype_document: number
}

const columns = [
    { type: 'text', field: 'code_system', label: 'Codigo', align: 'center' },
    { type: 'text', field: 'product', label: 'Producto', align: 'center' },
    { type: 'text', field: 'unitmeasure_abr', label: 'Und. Med.', align: 'center' },
    { type: 'text', field: 'amount', label: 'Cantidad', align: 'center' },
    { type: 'text', field: 'price', label: 'Precio', align: 'center', format: (row) => moneyCL(row.price) },
    // { type: 'text', field: 'discount', label: 'Descuento', align:'center', format:(row) => row.discounttype == 1 ? '$ ' + (row.discount || 0) : (row.discount || 0) + ' %' },
    { type: 'text', field: 'net_subtotal', label: 'Descuento ($)', align: 'center', format: (row) => moneyCL((row.price * row.amount) - row.net_subtotal) },
    { type: 'text', field: 'net_subtotal', label: 'Total', align: 'center', format: (row) => moneyCL(row.net_subtotal) },
];

const StyledTableCell = ({ children, ...props }) => (
    <TableCell sx={{ border: '1px solid #000000', ...props.sx }}>
        {children}
    </TableCell>
);

export const DocumentDetail: FC<DocumentDetailPros> = ({ ticket, idtype_document }) => {

    return (<>
        <Grid item container xs={12} md={12} sx={{ borderBottom: '4px solid #516E80', marginLeft: '16px', marginTop: '20px' }}>
            <Typography sx={{ backgroundColor: '#516E80', color: '#fff', marginRight: 'auto', padding: '5px 10px', marginLeft: '-16px' }}>Detalle</Typography>
        </Grid>
        <Grid item container xs={12} sx={{ marginTop: '-38px' }}>
            <CustomTable
                columns={columns}
                rows={ticket.details || []}
                withoutPagination
                colorColumns={'#516E80'}
                onRowClick={() => null}
                dense
            />
        </Grid>
        <Grid item container xs={12}>
            <Grid item xs={4} sx={{ marginLeft: 'auto' }}>
                <TableContainer>
                    <Table size="small">
                        <TableBody>
                            <TableRow key={1}>
                                <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                    Subtotal
                                </StyledTableCell>
                                <StyledTableCell align='center'>{moneyCL(ticket?.sub_total || 0)}</StyledTableCell>
                            </TableRow>
                            <TableRow key={1}>
                                <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                    Descuento
                                </StyledTableCell>
                                <StyledTableCell align='center'>{moneyCL(ticket.total_discount)}</StyledTableCell>
                            </TableRow>
                            <TableRow key={1}>
                                <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                    Monto Neto
                                </StyledTableCell>
                                <StyledTableCell align='center'>{moneyCL(ticket.net_total)}</StyledTableCell>
                            </TableRow>
                            {
                                idtype_document === 2 &&
                                <TableRow key={1}>
                                    <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                        Monto Excento
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>{moneyCL(0)}</StyledTableCell>
                                </TableRow>
                            }
                            <TableRow key={2}>
                                <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                    19% IVA
                                </StyledTableCell>
                                <StyledTableCell align='center'>{moneyCL(ticket.IVA)}</StyledTableCell>
                            </TableRow>
                            <TableRow key={3}>
                                <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                    TOTAL
                                </StyledTableCell>
                                <StyledTableCell align='center'>{moneyCL(ticket.gross_total)}</StyledTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    </>)
}